/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/* prettier-ignore */


export enum HavingFilterOperator {
    Greater = '>=',
    Lesser = '<=',
}